.TermsAndConditions {
  overflow: scroll;
  height: 60vh;
}

li {
  margin-top: 1rem;
}

.subTitle {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
